export default "<!-- EMPTY CELL -->\n";